// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect, useDispatch } from 'react-redux'
import { Container, InputGroup, Form, Button } from 'react-bootstrap'
import { applyPromoOnTicket, promocodePost } from '../../redux/actions/promoCodeAction'
import { errorMessage } from '../../constants/errorMessage'
import qrcode from '../../assets/img/qr-code.png'
import ScanQr from './ScanQr'
import { Circles } from 'react-loader-spinner'
import { getTicketDetails } from '../../redux/actions/ReceiptsAction'
import { getConfigDetails } from '../../services/config'
import {
    isLoggedIn,
    // isSessionNotActive,
    isValidPromoCode,
    loggedInUserData
} from '../../utils/helper'
// import { useCountDown } from '../../Hooks/countDownHook'
import CONSTANTS from '../../redux/constants'
import { addEventLog } from '../../redux/actions/EventsLog'
import { ticketValidation } from '../../redux/actions/ticketValidationAction'
import { useNavigate, useParams } from 'react-router-dom'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

function PromoCode(props) {
    const { facility, dispatch, promoCode, setPromoCode, setStateList, setFaciltyData,
        setValue, setErrorMessageLocal, length, isTicketApply, notify, setPaymentData,
        screen, ticketDetails, getValues, setIsPriceZero, discountAvailed, checkPromoWithLicense,
        checkPromo, promoCodeMsge, event_id, isRateChangedWithPromo, setIsRateChangedWithPromo,
        setIsSubmittingForm, setCustomeLoaderForRateBand, isPromoCodeAppiled, setIsPromoCodeApplied,
        resetPromo, setResetPromo, isSessionActive, selectedPastDate, setselctedDateTime,
        selctedDateTime, durationSelector, getHoursIndate, reqIDcurr } = props
    const localDispatch = useDispatch()
    // const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [scanResult, setScanResult] = useState(null)
    const [isScanDisplay, setIsScanDisplay] = useState(false)
    const [message, setMessage] = useState('')
    const [isError, setIsError] = useState(false)
    const [isApplyValidateCode, setIsApplyValidateCode] = useState(false)
    const [disablePromo, setDisablePromo] = useState(false)
    // const [isSessionActive, setIsSessionActive] = useState(true)

    const navigate = useNavigate()
    const { partner } = useParams()


    const facilityData = JSON.parse(localStorage.getItem('faclityData') ? localStorage.getItem('faclityData') : '{}')
    const rateData = JSON.parse(localStorage.getItem('seletedRateBand') ? localStorage.getItem('seletedRateBand') : '{}')

    const handlePromoCode = (e) => {
        e.preventDefault()
        const { value } = e.target
        let arr = value.split(' ')
        let str = arr.join('')

        setPromoCode(str?.toUpperCase())
        setIsError(false)
        setMessage('')
        if (value == '') {
            handleResetPromocode()
        }
    }

    // const [days, hours, minutes, seconds] = useCountDown(screen)
    // useEffect(() => {
    //     if (screen != 'transientForm') {
    //         const sessionStatus = isSessionNotActive(days, hours, minutes, seconds)
    //         setIsSessionActive(sessionStatus)
    //     }
    // }, [days, hours, minutes, seconds])

    useEffect(() => {
        if (scanResult) {
            setPromoCode(isValidPromoCode(scanResult, screen == 'transientForm') ? scanResult?.toUpperCase() : '')
            if (!isValidPromoCode(scanResult, screen == 'transientForm')) {
                setIsError(true)
                setShowMessage(true)
                setMessage(screen == 'transientForm' ? 'Please scan a valid QR code' : '')
            }
        }
    }, [scanResult])

    useEffect(() => {
        if (isRateChangedWithPromo && promoCode && promoCode != '') {
            handleSubmitPromoCode(((isPromoCodeAppiled && screen == 'transientForm') || screen != 'transientForm') ? promoCode : '', false)
            setIsRateChangedWithPromo((oldState) => {
                const newState = !oldState
                return newState
            })
        } else if(screen == 'transientForm') {
            handleSubmitPromoCode('', false)
        }
    }, [isRateChangedWithPromo])
    useEffect(() => {
        // handleResetPromocode()
        if (promoCodeMsge) {
            setMessage('')
            localDispatch({ type: CONSTANTS.PROMO_MSGE_DISABLE })
        }
    }, [length])

    useEffect(() => {
        if (ticketDetails?.promocode && ticketDetails?.promocode != '') {
            setIsPromoCodeApplied(true)
            setPromoCode(ticketDetails?.promocode)
            setMessage(`${ticketDetails?.promocode} applied`)
        }
        if(
            (ticketDetails?.permit_request_id && ticketDetails?.permit_request_id != null && ticketDetails?.permit_request_id != '') ||
            (ticketDetails?.user_pass_id && ticketDetails?.user_pass_id != null && ticketDetails?.user_pass_id != '') ||
            (ticketDetails?.reservation_id && ticketDetails?.reservation_id != null && ticketDetails?.reservation_id != '')
        ) {
            setDisablePromo(true)
        }

    }, [])

    useEffect(() => {
        if (checkPromo && checkPromoWithLicense) {
            handleSubmitPromoCode(checkPromoWithLicense)
        }
    }, [checkPromo])
    useEffect(() => {
        if (resetPromo && promoCode && isSessionActive) {
            let promoCheck = screen == 'transientForm' ? isPromoCodeAppiled : true
            handleResetPromocode(true, true, promoCheck)
        } else if(resetPromo) {
            setMessage('')
            setResetPromo(false)
            setPromoCode('')
            setValue('promo', '')
        }
    }, [resetPromo])

    const handleResetPromocode = (isRemoveActive = true, forceReset = false, applied = true) => {
        if (isPromoCodeAppiled || forceReset) {
            setResetPromo(false)
            if ((screen == 'transientForm' && isRemoveActive) || forceReset) {
                setValue('promo', '')
            }
            if (isRemoveActive || forceReset) {
                setPromoCode('')
            }

            if (isTicketApply) {
                const formData = getValues()
                const paymentDetails = (screen == 'extend' || screen == 'extendForm') ? JSON.parse(localStorage.getItem('ExtendData')) : JSON.parse(localStorage.getItem('paymentRecipt'))
                const finalPayload = {
                    ticket_id: paymentDetails?.ticket_number,
                    is_promocode_apply: '0',
                    promocode: promoCode
                }
                if (formData?.phone || loggedInUserData()?.user?.phone) {
                    finalPayload.phone = formData?.phone ? formData?.phone : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : ''
                }
                if (formData?.license_plate) {
                    finalPayload.license_plate = formData?.license_plate ? formData?.license_plate : ''
                }
                if (loggedInUserData()?.user?.email) {
                    finalPayload.email = loggedInUserData()?.user?.email
                }
                const loginData = loggedInUserData()
                if (loginData?.access_token) {
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                }
                
                dispatch(applyPromoOnTicket(finalPayload)).then((res) => {
                    setCustomeLoaderForRateBand(false)
                    if (res?.data) {
                        // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.base_amount}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_fee}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee}` }]
                        if (screen && (screen == 'extend' || screen == 'extendForm')) {
                            localStorage.removeItem('ExtendData')
                            localStorage.setItem('ExtendData', JSON.stringify(res?.data))
                        } else {
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
                        }
                        localStorage.setItem('isCouponApplied', false)
                        setPaymentData(res?.data)
                        setIsPromoCodeApplied(false)
                        setIsError(false)
                        setMessage(applied ? 'Validation Code Removed' : '')
                        setScanResult(null)
                        setShowMessage(true)
                        // setTimeout(() => {
                        //     setShowMessage(false)
                        //     setMessage('')
                        // }, 3000)
                        //NEED TO UPDATE THE PAYMENT DATA
                        //get ticket details
                        const payloadTicket = {
                            'ticket': paymentDetails?.ticket_number,
                            'phone': '',
                            'cardLast4': '',
                            'cardExpiry': '',
                            'license_plate': '',
                            'partner_id': getConfigDetails()?.PARTNER_ID,
                        }
                        dispatch(getTicketDetails(payloadTicket)).then((res) => {
                            if (res?.status === 201 || res?.status === 200) {
                                if (res?.data && res?.data != null) {
                                    // notify('success', 'T successfully')
                                    setPaymentData(res?.data)
                                    localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))


                                    // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(2))
                                } else {
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                    let errObject = {
                                        payload: payloadTicket,
                                        error: res,
                                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                                    }
                                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
                                }
                            } else {
                                // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                let errObject = {
                                    payload: payloadTicket,
                                    error: res,
                                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                                }
                                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
                            }
                        }).catch((err) => {
                            let errObject = {
                                payload: payloadTicket,
                                error: err,
                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
                            notify('error', errorMessage?.somethingWentWrong)
                        })
                        localDispatch({type: CONSTANTS.TICKET_EXTEND_API_RELOAD})
                        //end
                    } else {
                        setIsPromoCodeApplied(true)
                        notify('error', errorMessage?.somethingWentWrong)
                        setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsError(true)

                        if(res?.errors?.message && res?.errors?.detail && Object.keys(res?.errors?.detail).length > 0) {
                            let err = []
                            Object.keys(res?.errors?.detail).forEach(er => {
                                err.push(res?.errors?.detail[er])
                            })
                            setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                        } else {
                            setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                        let errObject = {
                            payload: finalPayload,
                            error: res,
                            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
                    }
                }).catch((err) => {
                    setCustomeLoaderForRateBand(false)
                    let errObject = {
                        payload: finalPayload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} applyPromoOnTicket-PromoCode.js-100`))
                    setIsPromoCodeApplied(true)
                    notify('error', errorMessage?.somethingWentWrong)
                    setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    if(err?.errors?.message && err?.errors?.detail && Object.keys(err?.errors?.detail).length > 0) {
                        let err = []
                        Object.keys(err?.errors?.detail).forEach(er => {
                            err.push(err?.errors?.detail[er])
                        })
                        setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                    } else {
                        setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                })
            } else {
                const formData = getValues()
                const finalPayload = {
                    'encrypt': facility,
                    'is_guest': isLoggedIn() ? '0' : '1'
                }
                if (facilityData?.facility?.is_price_band == 1 && rateData?.id) {
                    finalPayload.rate_band_id = (facilityData?.promo_category_id && facilityData?.promo_category_id != '') ? '' : rateData?.id
                    finalPayload.promocode = ''
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                } else {
                    if (length != 0 && Number(length) > 0 && (facilityData?.facility?.is_price_band != 1 || facilityData?.facility?.is_custom_picker_enabled == 1)) {
                        finalPayload.length = (facilityData?.promo_category_id && facilityData?.promo_category_id != '') ? '' : length
                    }
                }
                const loginData = loggedInUserData()
                if (loginData?.access_token) {
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                }
                if (formData?.phone || loggedInUserData()?.user?.phone) {
                    finalPayload.phone = formData?.phone ? formData?.phone : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : ''
                }
                if (formData?.license_plate) {
                    finalPayload.license_plate = formData?.license_plate ? formData?.license_plate : ''
                }
                if (loggedInUserData()?.user?.email) {
                    finalPayload.email = loggedInUserData()?.user?.email
                }
                
                if(formData?.is_vehicle_oversize){
                    finalPayload.is_vehicle_oversize = 1
                }
                dispatch(promocodePost(finalPayload)).then((res) => {
                    setCustomeLoaderForRateBand(false)
                    if (res?.data) {
                        if (Number(res?.data?.payable_amount) === 0) {
                            setIsPriceZero(true)
                            // reverting for price zero
                            // setIsPriceZero(false)
                        } else if (Number(res?.data?.payable_amount) > 0) {
                            setIsPriceZero(false)
                        }
                        if (isRemoveActive) {
                            setIsPromoCodeApplied(false)
                        }



                        localStorage.setItem('faclityData', JSON.stringify(res?.data))

                        setStateList(res?.data?.states)
                        setFaciltyData(res?.data)
                        if (isRemoveActive) {
                            localStorage.setItem('isCouponApplied', false)
                        }
                        const geoState = res?.data?.facility?.geolocations?.state
                        const filteredState = res?.data?.states?.filter((item) => item?.state_code === geoState ? item : 0)
                        if (screen == 'transientForm') {
                            setValue('state', filteredState[0]?.id)
                        }
                        if (isRemoveActive) {

                            setIsError(false)
                            setMessage(applied ? 'Validation Code Removed' : '')
                            setShowMessage(true)
                        }
                        // setTimeout(() => {
                        //     setShowMessage(false)
                        //     setMessage('')
                        // }, 3000)
                    } else {
                        setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsError(true)
                        if(res?.errors?.message && res?.errors?.detail && Object.keys(res?.errors?.detail).length > 0) {
                            let err = []
                            Object.keys(res?.errors?.detail).forEach(er => {
                                err.push(res?.errors?.detail[er])
                            })
                            setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                        } else {
                            setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                        let errObject = {
                            payload: finalPayload,
                            error: res,
                            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} promocodePost-PromoCode.js-186`))
                    }
                }).catch((err) => {
                    setCustomeLoaderForRateBand(false)
                    let errObject = {
                        payload: finalPayload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} promocodePost-PromoCode.js-186`))
                    setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    if(err?.errors?.message && err?.errors?.detail && Object.keys(err?.errors?.detail).length > 0) {
                        let err = []
                        Object.keys(err?.errors?.detail).forEach(er => {
                            err.push(err?.errors?.detail[er])
                        })
                        setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                    } else {
                        setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                })
            }
        } else {
            setPromoCode('')
        }
    }

    const handleSubmitPromoCode = (promo = null, promoBTN = true) => {
        setIsApplyValidateCode(true)
        setMessage('')
        let promoUpd = promo ? promo : promoBTN ? promoCode : (!promoBTN && isPromoCodeAppiled) ? promoCode : ''
        if (screen == 'transientForm') {
            setValue('promo', promoUpd)
        }
        // NOTE:- faciltyData?.paid_type === '9' means ticket is not validated except from this restrict promocode:- condition from @Vikrant
        if ((promoUpd !== '' && promoUpd !== null && (discountAvailed && discountAvailed == '9')) || !promoBTN) {
            if (isTicketApply) {

                const paymentDetails = (screen == 'extend' || screen == 'extendForm') ? JSON.parse(localStorage.getItem('ExtendData')) : JSON.parse(localStorage.getItem('paymentRecipt'))
                const finalPayload = {
                    ticket_id: paymentDetails?.ticket_number,
                    is_promocode_apply: '1',
                    'phone': paymentDetails?.user?.phone_number ? paymentDetails?.user?.phone_number : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : '',
                    'license_plate': paymentDetails?.user?.license_plate ? paymentDetails?.user?.license_plate : '',
                    'email': loggedInUserData()?.user?.email
                }

                if(selectedPastDate) {
                    finalPayload.start_date = selectedPastDate
                }

                if (promoUpd) {
                    finalPayload.promocode = promoUpd
                }

                if (facilityData?.facility?.is_price_band == 1 && rateData?.id) {
                    finalPayload.rate_band_id = rateData?.id
                } else {
                    if (length != 0 && Number(length) > 0 && (facilityData?.facility?.is_price_band != 1 || facilityData?.facility?.is_custom_picker_enabled == 1)) {
                        finalPayload.length = length
                    }
                }
                const loginData = loggedInUserData()
                if (loginData?.access_token) {
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                }

                dispatch(applyPromoOnTicket(finalPayload)).then((res) => {
                    setCustomeLoaderForRateBand(false)
                    // setIsPromoCodeApplied(true)
                    if (res?.data) {
                        setIsSubmittingForm(false)
                        setIsApplyValidateCode(false)
                        localStorage.setItem('isCouponApplied', true)
                        setPaymentData(res?.data)
                        setIsError(false)
                        // setMessage('Validation Code Applied Successfully')
                        if (promoUpd) {
                            setIsPromoCodeApplied(true)
                            setMessage(`${promoUpd} applied`)
                        }
                        //get ticket details
                        const payloadTicket = {
                            'ticket': paymentDetails?.ticket_number,
                            'phone': '',
                            'cardLast4': '',
                            'cardExpiry': '',
                            'license_plate': '',
                            'partner_id': getConfigDetails()?.PARTNER_ID,
                        }
                        dispatch(getTicketDetails(payloadTicket)).then((res) => {
                            if (res?.status === 201 || res?.status === 200) {
                                if (res?.data && res?.data != null) {
                                    // notify('success', 'T successfully')
                                    setPaymentData(res?.data)
                                    localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))


                                    // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(2))
                                } else {
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                    let errObject = {
                                        payload: payloadTicket,
                                        error: res,
                                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                                    }
                                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-276`))
                                }
                            } else {
                                // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                let errObject = {
                                    payload: payloadTicket,
                                    error: res,
                                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                                }
                                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-276`))
                            }
                        }).catch((err) => {
                            let errObject = {
                                payload: payloadTicket,
                                error: err,
                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-276`))
                            notify('error', errorMessage?.somethingWentWrong)
                        })
                        setShowMessage(true)
                        // setTimeout(() => {
                        //     setShowMessage(false)
                        //     setMessage('')
                        // }, 3000)
                        //end
                    } else {
                        setIsSubmittingForm(false)
                        // notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsApplyValidateCode(false)

                        localStorage.setItem('isCouponApplied', false)
                        // setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsError(true)
                        if(res?.errors?.message && res?.errors?.detail && Object.keys(res?.errors?.detail).length > 0) {
                            let err = []
                            Object.keys(res?.errors?.detail).forEach(er => {
                                err.push(res?.errors?.detail[er])
                            })
                            setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                        } else {
                            setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }

                        // Refresh the Rate API without Promocode
                        handleResetPromocode(false)


                        let errObject = {
                            payload: finalPayload,
                            error: res,
                            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} applyPromoOnTicket-PromoCode.js-257`))
                    }
                }).catch((err) => {
                    setCustomeLoaderForRateBand(false)
                    setIsSubmittingForm(false)

                    // Refresh the Rate API without Promocode
                    handleResetPromocode(false)


                    let errObject = {
                        payload: finalPayload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} applyPromoOnTicket-PromoCode.js-257`))
                    // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsApplyValidateCode(false)

                    localStorage.setItem('isCouponApplied', false)
                    // setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    if(err?.errors?.message && err?.errors?.detail && Object.keys(err?.errors?.detail).length > 0) {
                        let err = []
                        Object.keys(err?.errors?.detail).forEach(er => {
                            err.push(err?.errors?.detail[er])
                        })
                        setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                    } else {
                        setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    // setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            } else {
                const formData = getValues()
                // if (length > 0 || formData?.rate_band_id) {
                const finalPayload = {
                    'encrypt': facility,
                    'is_guest': isLoggedIn() ? '0' : '1',
                    'phone': formData?.phone ? formData?.phone : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : '',
                    'license_plate': formData?.license_plate ? formData?.license_plate : '',
                    'email': loggedInUserData()?.user?.email
                }

                if(selectedPastDate) {
                    finalPayload.start_date = selectedPastDate
                }

                if (promoUpd) {
                    finalPayload.promocode = promoUpd
                }
                if (event_id) {
                    finalPayload.event_id = event_id
                } else if (facilityData?.facility?.is_price_band == 1 && rateData?.id) {
                    finalPayload.rate_band_id = rateData?.id
                } else {
                    if (length != 0 && Number(length) > 0 && (facilityData?.facility?.is_price_band != 1 || facilityData?.facility?.is_custom_picker_enabled == 1)) {
                        finalPayload.length = length
                    }
                }
                const loginData = loggedInUserData()
                if (loginData?.access_token) {
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                }
                
                if(formData?.is_vehicle_oversize){
                    finalPayload.is_vehicle_oversize = 1
                }
                const reqID = reqIDcurr?.current ? ++reqIDcurr.current : null
                dispatch(promocodePost(finalPayload)).then((res) => {
                    if((!reqID || reqID == reqIDcurr?.current)) {
                        setCustomeLoaderForRateBand(false)
                        if (res?.data) {
                            if ((length != 0 && Number(length) > 0) && facilityData?.facility?.is_custom_picker_enabled == 1 && !finalPayload?.event_id && !finalPayload.rate_band_id) {
                                setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(finalPayload.length) })
                            }
                            setIsSubmittingForm(false)
                            setIsApplyValidateCode(false)
                            if (Number(res?.data?.payable_amount) === 0) {
                                setIsPriceZero(true)
                                // reverting for price zero
                                // setIsPriceZero(false)
                            } else if (Number(res?.data?.payable_amount) > 0) {
                                setIsPriceZero(false)
                            }

                            localStorage.setItem('faclityData', JSON.stringify(res?.data))
                            setStateList(res?.data?.states)
                            setFaciltyData(res?.data)
                            localStorage.setItem('isCouponApplied', true)
                            const geoState = res?.data?.facility?.geolocations?.state
                            const filteredState = res?.data?.states?.filter((item) => item?.state_code === geoState ? item : 0)
                            if (screen == 'transientForm') {
                                setValue('state', filteredState[0]?.id)
                            }
                            setIsError(false)
                            // setMessage('Validation Code Applied Successfully')
                            if (promoUpd) {
                                setIsPromoCodeApplied(true)
                                setMessage(`${promoUpd} applied`)
                            }
                            setShowMessage(true)
                            // setTimeout(() => {
                            //     setShowMessage(false)
                            //     setMessage('')
                            // }, 3000)
                            if((res?.data?.facility?.facility_configuration?.is_facility_hotel_type == '1' && durationSelector == '1' && Number(res.data?.parking_amount) > 0)) {
                                setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(finalPayload.length) })
                            }
                        } else {
                            setIsSubmittingForm(false)
                            setIsApplyValidateCode(false)
                            setIsError(true)
                            localStorage.setItem('isCouponApplied', false)

                            if(res?.errors?.message && res?.errors?.detail && Object.keys(res?.errors?.detail).length > 0) {
                                let err = []
                                Object.keys(res?.errors?.detail).forEach(er => {
                                    err.push(res?.errors?.detail[er])
                                })
                                setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                            } else {
                                setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)

                            // Refresh the Rate API without Promocode
                            handleResetPromocode(false)

                            let errObject = {
                                payload: finalPayload,
                                error: res,
                                errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} promocodePost-PromoCode.js-257`))
                        }
                    }
                }).catch((err) => {
                    setCustomeLoaderForRateBand(false)
                    setIsSubmittingForm(false)

                    // Refresh the Rate API without Promocode
                    handleResetPromocode(false)

                    let errObject = {
                        payload: finalPayload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} promocodePost-PromoCode.js-257`))
                    setIsApplyValidateCode(false)
                    setIsError(true)
                    localStorage.setItem('isCouponApplied', false)
                    // console.log('err', err)
                    if(err?.errors?.message && err?.errors?.detail && Object.keys(err?.errors?.detail).length > 0) {
                        let err = []
                        Object.keys(err?.errors?.detail).forEach(er => {
                            err.push(err?.errors?.detail[er])
                        })
                        setMessage(err.length > 0 ? err.join('. ') : errorMessage?.somethingWentWrong)
                    } else {
                        setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
                // } else {
                //     setIsApplyValidateCode(false)
                //     notify('error', 'Please select valid duration.')
                // }
            }

        } else if (discountAvailed && discountAvailed != '9') {
            setIsApplyValidateCode(false)
            notify('error', 'The Validation discount already availed.')
        } else {
            setIsApplyValidateCode(false)
            setIsError(true)
            setMessage('Please enter a validation code')
        }

    }

    const handleQrScan = () => {
        if (isSessionActive && !ticketDetails?.promocode && !disablePromo) {
            setIsScanDisplay(true)
        }
    }

    const apifuntocall = (qrcodeId, ticketNumber) => {
        const payload = { 'ticket_number': ticketNumber, channel: 'web', business_qrcode: qrcodeId }
        setIsApplyValidateCode(true)
        dispatch(ticketValidation(payload)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                getUpdatedTicketDetails(ticketNumber)
                if(screen == 'paymentResponse' || screen == 'transientForm'){
                    navigate(`/${partner}/paymentResponse/${res?.data?.ticket_number || ticketNumber}`)
                }else if(screen == 'extendForm' || screen == 'extend'){
                    navigate(`/${partner}/extend-success/${res?.data?.ticket_number || ticketNumber}`)
                }
                notify('success', 'E-Ticket has been validated successfully.')
            } else {
                notify(
                    'error',
                    res?.errors?.message
                        ? res?.errors?.message
                        : errorMessage?.somethingWentWrong
                )
                // navigate(`/${partner}/paymentResponse`)
            }
            setIsApplyValidateCode(false)
        })
    }

    const getUpdatedTicketDetails = (ticketNumber) => {
        const payloadTicket = {
            'ticket': ticketNumber,
            'phone': '',
            'cardLast4': '',
            'cardExpiry': '',
            'license_plate': '',
            'partner_id': getConfigDetails()?.PARTNER_ID,
        }
        dispatch(getTicketDetails(payloadTicket)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                if (res?.data && res?.data != null) {
                    // notify('success', 'T successfully')
                    setPaymentData(res?.data)
                    localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))


                    // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(2))
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    let errObject = {
                        payload: payloadTicket,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
                }
            } else {
                // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                let errObject = {
                    payload: payloadTicket,
                    error: res,
                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
            }
        }).catch((err) => {
            let errObject = {
                payload: payloadTicket,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
            notify('error', errorMessage?.somethingWentWrong)
        })
    }
    return (
        <div><Container className='mb-3 mt-3'>
            {/* <Form.Label className='text-info styleLables'>Promo Code</Form.Label> */}
            <InputGroup className=" myiconset border rounded d-flex justify-content-center align-items-center">
                <Form.Control className='border-0' placeholder="Validation Code" aria-label="PromoCode" aria-describedby="basic-addon2" value={promoCode} disabled={!isSessionActive || ticketDetails?.promocode || isPromoCodeAppiled || (discountAvailed && discountAvailed != '9') || disablePromo} onChange={handlePromoCode} />
                {(!isPromoCodeAppiled && !ticketDetails?.promocode) ?
                    <Button disabled={isApplyValidateCode || !isSessionActive || (discountAvailed && discountAvailed != '9')} className='border-0' variant=" text-primary" type='button' id="button-addon2" onClick={() => handleSubmitPromoCode(null)}>
                        {!disablePromo && <div className='d-flex'>
                            <span className='me-2'>Apply</span>
                            {isApplyValidateCode ?
                                <Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                />
                                : ''}

                        </div>}
                    </Button> : (isSessionActive && !ticketDetails?.promocode && promoCode) ? <Button variant=" text-danger" type='button' disabled={!isSessionActive || (discountAvailed && discountAvailed != '9')} id="button-addon2" onClick={handleResetPromocode}><i className='fa-1x fa fa-times'> </i></Button> : ''
                }
                <img src={qrcode} className={`${(!isSessionActive || ticketDetails?.promocode) ? 'ms-2 ' : ''}me-2 qr-img`} alt="Scan QR for Code" onClick={() => (discountAvailed && discountAvailed != '9') ? null : handleQrScan()} />
            </InputGroup>
            <span className={isError ? 'text-danger small text-left mt-1' : 'text-success small text-left mt-1'}>{(isPromoCodeAppiled && showMessage && message) ? <i className='me-1 fa fa-check-circle'></i> : ''}{message}</span>
        </Container>
            {isScanDisplay && <ScanQr 
                setScanResult={setScanResult} 
                scanResult={scanResult} 
                setIsScanDisplay={setIsScanDisplay} 
                handleSubmitPromoCode={handleSubmitPromoCode} 
                handleValidateTicket={apifuntocall} 
                promocodePage={true} 
                setPromoCode={setPromoCode} 
                notify={notify}
                screen={screen} />}
        </div>
    )
}

PromoCode.propTypes = {
    dispatch: PropTypes.func,
    facility: PropTypes.string,
    setStateList: PropTypes.func,
    setFaciltyData: PropTypes.func,
    setValue: PropTypes.func,
    setErrorMessageLocal: PropTypes.func,
    length: PropTypes.string,
    isTicketApply: PropTypes.bool,
    notify: PropTypes.func,
    setPaymentData: PropTypes.func,
    setIsPriceZero: PropTypes.func,
    screen: PropTypes.string,
    resetPromocode: PropTypes.bool,
    ticketDetails: PropTypes.object,
    getValues: PropTypes.func,
    discountAvailed: PropTypes.string,
    checkPromoWithLicense: PropTypes.string,
    checkPromo: PropTypes.string,
    event_id: PropTypes.string,
    promoCodeMsge: PropTypes.bool,
    promoCode: PropTypes.string,
    setPromoCode: PropTypes.func,
    isRateChangedWithPromo: PropTypes.bool,
    setIsRateChangedWithPromo: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setCustomeLoaderForRateBand: PropTypes.func,
    setIsPromoCodeApplied: PropTypes.func,
    isPromoCodeAppiled: PropTypes.bool,
    setResetPromo: PropTypes.func,
    resetPromo: PropTypes.bool,
    isSessionActive: PropTypes.bool,
    selectedPastDate: PropTypes.string,
    setselctedDateTime: PropTypes.func,
    selctedDateTime: PropTypes.object,
    durationSelector: PropTypes.string,
    getHoursIndate: PropTypes.func,
    reqIDcurr: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
}

PromoCode.defaulProps = {
    dispatch: noop,
    facility: '',
    setStateList: noop,
    setFaciltyData: noop,
    setValue: noop,
    setErrorMessageLocal: noop,
    length: '',
    isTicketApply: false,
    notify: noop,
    setPaymentData: noop,
    setIsPriceZero: noop,
    screen: '',
    resetPromocode: false,
    PropTypes: noop,
    getValues: noop,
    discountAvailed: '',
    checkPromoWithLicense: '',
    checkPromo: '',
    event_id: '',
    promoCodeMsge: false,
    promoCode: '',
    setPromoCode: noop,
    isRateChangedWithPromo: false,
    setIsRateChangedWithPromo: noop,
    setIsSubmittingForm: noop,
    setCustomeLoaderForRateBand: noop,
    setIsPromoCodeApplied: noop,
    isPromoCodeAppiled: false,
    setResetPromo: noop,
    resetPromo: false,
    isSessionActive: true,
    selectedPastDate: '',
    setselctedDateTime: noop,
    selctedDateTime: EMPTY_OBJECT,
    durationSelector: '',
    getHoursIndate: noop,
    reqIDcurr: null
}

function mapStateToProps({ transientReducer, PaymentReducer }) {
    return {
        promoCodeMsge: transientReducer.promoCodeMsge,
        isSessionActive: PaymentReducer.activeSession,
    }
}
export default connect(mapStateToProps)(PromoCode)